import { render, staticRenderFns } from "./store-detail.vue?vue&type=template&id=d97a485a&scoped=true&"
import script from "./store-detail.vue?vue&type=script&lang=js&"
export * from "./store-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97a485a",
  null
  
)

export default component.exports